import { FC } from 'react';
import { Box, Text, TextProps } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import useHideTemplateCountDisplay from '@components/Hooks/useHideTemplateCountDisplay';
import s from './TemplateCountDisplay.module.scss';

interface Props {
  templateCount?: number;
}

const TemplateCountDisplay: FC<Props> = ({ templateCount }) => {
  const { t } = useTranslation();
  const { isHidden } = useHideTemplateCountDisplay();

  if (!Number.isInteger(templateCount) || isHidden) {
    return <Box />;
  }

  const text = t('marketplace.templates-page.template-count.studio-short', {
    count: templateCount,
  });

  const weight = 'thin';
  const props = {
    className: s.coloredText,
    weight,
  } as TextProps;

  return (
    <Box>
      <Text {...props}>{text}</Text>
    </Box>
  );
};

export default TemplateCountDisplay;
